import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { SpBuilderBoardTypeDto } from './sp-builder-board-type.dto';
import { SpBuilderBoardTypeMapableInterface } from '../interfaces/sp-builder-board-type-mapable.interface';

export class SpBuilderBoardTypeMapableDto
  extends IntersectionType(
    PickType(SpBuilderBoardTypeDto, ['itemDescription', 'builderId']),
    PartialType(PickType(SpBuilderBoardTypeDto, ['active', 'boardTypeId'])),
  )
  implements SpBuilderBoardTypeMapableInterface {}
